import React from "react";
import TaxTablePageGen from "./generated/TaxTablePageGen";
import taxTableService from "../../../services/legacy/taxTableService";

const SHOW_IN_GRID = new Set(["country", "taxgroupcust", "taxgroupinvent", "percentcalc"]);
const SHOW_IN_FILTER = new Set(["country", "taxgroupcust", "taxgroupinvent"]);

const transformColumns = (baseColumns) => {
  return baseColumns.map((column) => ({
    ...column,
    showInGrid: SHOW_IN_GRID.has(column.key),
    showInFilter: SHOW_IN_FILTER.has(column.key),
  }));
};

const TaxTablePage = () => {
  const service = taxTableService;
  return <TaxTablePageGen service={service} transformColumns={transformColumns} />;
};

export default TaxTablePage;